<template>
  <div>
    <div class="form-group select2 treeview" :class="setPlaceholderClasses">
      <treeselect
        :clearable="clearable"
        :placeholder="placeholder"
        :multiple="multiple"
        :valueFormat="valueFormat"
        :options="options"
        :flat="multiple"
        :disabled="disabled"
        :sort-value-by="sortValueBy"
        :value="value"
        :id="id"
        class="form-control"
        @input="update()"
        ref="input"
      >
        <div
          slot="value-label"
          slot-scope="{ node }"
          v-html="getValueLabel(node)"
        ></div>
      </treeselect>
      <label :for="id">{{ text }}</label>
    </div>
  </div>
</template>
<script>
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import placeholder from "@mixins/placeholder.js";
import placeholder from "@mixins/placeholder.js";
export default {
  name: "volcan-select2-treeview",
  // mixins: [placeholder],
  mixins: [placeholder],
  components: { Treeselect },
  props: {
    value: null,
    text: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    options: Array,
    multiple: {
      type: Boolean,
      default: true,
    },
    sortValueBy: {
      type: String,
      default: "ORDER_SELECTED",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    valueFormat: {
      type: String,
      default: "object",
    },
  },
  data: function () {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  methods: {
    update() {
      this.$emit("input", this.$refs.input.getValue());
    },
    getValueLabel(node) {
      return (
        (node.raw.parentNames ? node.raw.parentNames + " > " : "") + node.label
      );
    },
  },
};
</script>
<style>
.vue-treeselect__input {
  border: none !important;
}

.vue-treeselect__control {
  border: none !important;
}

.vue-treeselect__placeholder {
  margin-top: 5px !important;
}

.vue-treeselect__list label {
  position: relative;
  color: #000;
  top: 18px;
  left: 0;
  background: none;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-select2-treeview.vue